<template>
<div :class="['news-item', {'grid-aspect': column_superseded}, {'columns is-variable is-2': !column_superseded}, {'is-mobile': !is_mobile}]">
    <div class="column is-narrow" v-if="!is_mobile && !column_superseded">
        <time class="has-text-centered news-item__date is-block bg-dark-blue" :datetime="item.release.full">
            <span class="is-block news-item__date__day">{{item.release.date}}</span>
            <span class="is-block news-item__date__month-year">{{item.release.month}}, {{item.release.year}}</span>
        </time>
        <span class="news-item__icon is-block has-text-centered bg-white colour-dark-blue">
            <i class="fas fa-pencil-alt"></i>
        </span>
    </div>
    <div :class="{'column is-4': !column_superseded}">
        <router-link v-if="!item.is_external" class="is-block" :to="item.link">
            <figure v-if="item.image" :class="{'is-paddingless': column_superseded}">
                <img :src="item.image.url" :alt="item.title" class="is-block" />
            </figure>
        </router-link>
        <a v-else class="is-block" :href="item.link" target="_blank">
            <figure v-if="item.image">
                <img :src="item.image.url" :alt="item.title" class="is-block" />
            </figure>
        </a>
        <div class="columns mobile-only-release-date is-mobile" v-if="is_mobile || column_superseded">
            <div class="column is-narrow">
                <span class="news-item__icon is-block has-text-centered bg-white colour-dark-blue">
                    <i class="fas fa-pencil-alt"></i>
                </span>
            </div>
            <div class="column">
                <time class="has-text-centered news-item__date is-block bg-dark-blue" :datetime="item.release.full">
                    <span class="is-block news-item__date__day">{{item.release.date}}</span>
                    <span class="is-block news-item__date__month-year">{{item.release.month}}, {{item.release.year}}</span>
                </time>
            </div>
        </div>
    </div>
    <div :class="{'column': !column_superseded}">
        <h3 class="news-item__title title colour-orange">
            <router-link v-if="!item.is_external" class="colour-orange" :to="item.link">{{item.title}}</router-link>
            <a v-else class="colour-orange" :href="item.link" target="_blank">{{item.title}}</a>
        </h3>
        <div ref="content" class="content" v-html="item.content"></div>
        <div :class="['news-item__cta', {'has-text-right': !column_superseded}]">
            <router-link v-if="!item.is_external" class="colour-orange" :to="item.link">Read More ›</router-link>
            <a v-else target="_blank" class="colour-orange" :href="item.link">Read More ›</a>
        </div>
    </div>
</div>
</template>

<script>
import WindowResizeHandler from '@/components/mixins/WindowResizeHandler';
import ViewBlockItemMixin from '@/components/mixins/ViewBlockItemMixin';
export default {
    name        :   'NewsItem',
    mixins      :   [ WindowResizeHandler, ViewBlockItemMixin ],
    props       :   ['item'],
    data()
    {
        return {
            is_mobile   :   false,
            is_pad      :   false,
            col_size    :   4
        }
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
    methods :   {
        handle_window_resize(width)
        {
            this.is_mobile  =   width < 768;
            if (width >= 768 && width < 960) {
                this.col_size   =   6;
                this.is_pad     =   true;
            } else {
                this.col_size   =   4;
                this.is_pad     =   false;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/NewsItem.vue